import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, ButtonGroup, Checkbox, CircularProgress, FormControlLabel, FormGroup, Grid, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { getUserFullName, uniqueListByPropertyName } from 'app/utils/appHelpers';
import { ASSET_IMAGES } from 'app/utils/constants/paths';
import { getUnitsFromPageType } from 'app/utils/meetingReduxHelpers';
import config from 'config';
import 'dayjs/locale/tr';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';


function MeetingDataTableFilter({ data, setFilterData }) {

  const location = useLocation();
  const [selectedFilters, setSelectedFilters] = React.useState([]);
  const [state, setState] = React.useState({
    startedDate: null,
    finishedDate: null,
    checkedInst: {
      AKM: false,
      TDK: false,
      ATAM: false,
      TTK: false,
      YK: false,
      other: false,
      list: []
    },
    selectedDataUnits: [],
    dataUnit: []

  });

  const [dataUnit, setDataUnit] = useState([]);
  const [selectedDataUnits, setSelectedDataUnits] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUserList, setSelectedUserList] = useState([]);
  const { startedDate, finishedDate } = state;
  const [completedMeetings, setCompletedMeetings] = useState(false);
  const [ongoingMeetings, setOngoingMeetings] = useState(false);
  const [loading, setLoading] = useState(false);
  const [instList, setInstList] = useState([]);
  const { data: userList } = useSelector(state => state.user);
  const pageType = useSelector(state => state.meeting.pageType);
  const allUsersMeetingList = useSelector((state) => state.meeting.allUsersMeetingList);
  const authStore = useSelector(state => state.auth);

  // URL'den gelen inst parametresine göre başlangıçta ilgili kurum kutucuğunu seçili yap
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const instParam = searchParams.get('inst');

    if (!instParam) return;

    // Sadece tanımlı kurum kodları için çalışsın
    if (!['YK', 'AKM', 'ATAM', 'TDK', 'TTK'].includes(instParam)) return;

    setState((prev) => {
      const newCheckedInst = {
        ...prev.checkedInst,
        AKM: false,
        TDK: false,
        ATAM: false,
        TTK: false,
        YK: false,
        [instParam]: true,
      };

      return {
        ...prev,
        checkedInst: newCheckedInst,
      };
    });
  }, [location.search]);


  useEffect(() => {

    let tempData = [...data];

    if (state.startedDate) {
      tempData = tempData.filter(x => new Date(x.pdate) >= new Date(state.startedDate));
    }

    if (state.finishedDate) {
      tempData = tempData.filter(x => new Date(x.pdate) <= new Date(state.finishedDate));
    }

    if (state.checkedInst.YK || state.checkedInst.AKM || state.checkedInst.ATAM || state.checkedInst.TTK || state.checkedInst.TDK) {
      tempData = tempData.filter(x => (
        (state.checkedInst.AKM && x.inst === "AKM")
        || (state.checkedInst.ATAM && x.inst === "ATAM")
        || (state.checkedInst.TDK && x.inst === "TDK")
        || (state.checkedInst.TTK && x.inst === "TTK")
        || (state.checkedInst.YK && x.inst === "YK")
      )
      )
    }
    if (dataUnit.length > 0) {

      tempData = tempData.filter((item) =>
        selectedDataUnits.length === 0 || selectedDataUnits.some((unit) => unit.id === item.unitId)
      );
    }

    if (users.length > 0) {
      tempData = tempData.filter((item) =>
        selectedUserList.length === 0 || selectedUserList.some((user) => user.id === item.adminUserId)
      );
    }


    if (completedMeetings) {
      tempData = tempData.filter(item => item.statFinish === 1);
    }

    if (ongoingMeetings) {
      tempData = tempData.filter(item => item.statFinish === 0);
    }
    setFilterData(tempData)

  }, [data, state, selectedDataUnits, selectedUserList, completedMeetings, ongoingMeetings])




  useEffect(() => {
    const getAPI = async () => {

      try {

        setLoading(true);

        let datalist = uniqueListByPropertyName(data, "adminUserId");
        let userlist = [];
        datalist.forEach(element => {
          const user = userList.find(item => item.id === element);
          if (user) {
            userlist.push(user);
          }
        });
        setUsers(userlist);

        let insts = uniqueListByPropertyName(data, "inst");

        let instlist = [];
        insts.forEach(element => {
          const inst = config.institutions.find(item => item.inst === element);
          if (inst) {
            instlist.push(inst);
          }
        });
        instlist = instlist.map(item => item.inst);
        setInstList(instlist);

        let units = [];
        units = getUnitsFromPageType({ authStore }, pageType);
        setDataUnit(units);

        setLoading(false)
      } catch (error) {
        console.error("Error fetching data:", error);
      }

    }

    getAPI()
  }, [data, pageType, allUsersMeetingList, ongoingMeetings])



  const clearFilter = () => {
    setSelectedUserList([]);
    setSelectedDataUnits([]);
    setState({
      ...state,
      startedDate: null,
      finishedDate: null,
      checkedInst: {
        AKM: false,
        TDK: false,
        ATAM: false,
        TTK: false,
        YK: false,
        other: false,
        list: []

      }
    });
    setFilterData([]);
    setCompletedMeetings(false);
    setOngoingMeetings(false);
    setSelectedFilters([]);

  }

  const handleChangeCheckedInst = (name) => event => {
    const newCheckedInst = { ...state.checkedInst, [name]: event.target.checked };
    setState({
      ...state,
      checkedInst: newCheckedInst,

    })

  }

  const handleChangeCheckedFinish = (event) => {
    const { value, checked } = event.target;

    if (value === "Tamamlanan Toplantılar") {
      setCompletedMeetings(checked);
    } else if (value === "İşlemi devam edenler") {
      setOngoingMeetings(checked);
    }


  };


  const fontSettings = useSelector((state) => state.meeting.fontSettings);
  const { baseFontSize } = fontSettings

  return (

    <Accordion

      sx={{
        background: '#e1e1e1',
        fontSize: baseFontSize, // Tüm Accordion içeriği 12px olacak
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"

        sx={{
          minHeight: '40px', // Accordion başlığının yüksekliğini azaltıyoruz
          '& .MuiAccordionSummary-content': {
            margin: '4px 0', // İçeriğin margin'ini azaltıyoruz
          },
        }}

      >
        <Typography>
          Filtreler
          {completedMeetings && " / Tamamlanan Toplantılar"}
          {ongoingMeetings && " / İşlemi devam edenler"}

        </Typography>
      </AccordionSummary>


      <AccordionDetails

        sx={{
          // height: '50px',
          fontSize: '14px',
          '& *': {
            fontSize: 'inherit'
          }
        }}
      >

        <Grid container item xs={12} sm={12} lg={12}

          sx={{ background: '#e1e1e1', fontSize: baseFontSize }}

        >

          <Grid item xs={12} sm={4} lg={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"tr"}>

              <DatePicker
                label="Başlangıç"
                value={startedDate}
                onChange={(newValue) => {
                  setState({ ...state, startedDate: newValue });
                }}
                renderInput={(params) => <TextField size="small" sx={{ m: 1 }}  {...params} />}
              />

              <DatePicker
                label="Bitiş"
                className='m-1'
                value={finishedDate}
                onChange={(newValue) => {
                  setState({ ...state, finishedDate: newValue });
                }}
                renderInput={(params) => <TextField size="small" sx={{ m: 1 }} {...params} />}
              />

            </LocalizationProvider>
          </Grid>


          {loading ? <CircularProgress /> :
            <Grid item xs={12} sm={4} lg={2}>

              <Grid item xs={12} sm={12} lg={12} padding={1}>

                <Autocomplete
                  multiple
                  id="autocomplete"
                  options={dataUnit}
                  size='small'
                  getOptionLabel={(option) => option.name}
                  value={selectedDataUnits}
                  onChange={(event, newValue) => {
                    setSelectedDataUnits(newValue);

                  }}
                  componentsProps={{
                    popper: {
                      sx: {
                        '& .MuiAutocomplete-listbox': {
                          fontSize: baseFontSize, // Açılır menüdeki seçeneklerin font boyutu
                        },
                      },
                    },
                  }}

                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Kurul/Kol/Komisyon"
                      placeholder="Kurul/Kol/Komisyon seçiniz"
                    />
                  )}
                />

              </Grid>

              <Grid item xs={12} sm={12} lg={12} padding={1}>
                <Autocomplete
                  multiple
                  size='small'
                  id="autocomplete"
                  options={users}
                  getOptionLabel={(option) => getUserFullName(option)}
                  value={selectedUserList}
                  onChange={(event, newValue) => {
                    setSelectedUserList(newValue);

                  }}
                  componentsProps={{
                    popper: {
                      sx: {
                        '& .MuiAutocomplete-listbox': {
                          fontSize: baseFontSize, // Açılır menüdeki seçeneklerin font boyutu
                        },
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Kullanıcı"
                      placeholder="Kullanıcı Seçiniz"
                    />
                  )}
                />
              </Grid>

            </Grid>

          }



          <Grid item xs={12} sm={3} lg={3} sx={{ alignSelf: 'center', textAlign: 'center' }}>


            <FormGroup row >

              {instList.includes("YK") && (
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={state.checkedInst.YK}
                      onChange={handleChangeCheckedInst('YK')}
                      value="YK"
                    />
                  }
                  label={
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        src={`${ASSET_IMAGES}/logos/YK.png`}
                        width="30px"
                        alt="Yönetim Kurulu"
                        title="Yönetim Kurulu"
                      />
                      <span style={{ marginLeft: '8px' }}>YK</span>
                    </div>
                  }
                />
              )}

              <Grid container spacing={1}>
                {instList.includes("ATAM") && (
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={state.checkedInst.ATAM}
                          onChange={handleChangeCheckedInst('ATAM')}
                          value="ATAM"
                        />
                      }
                      label={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={`${ASSET_IMAGES}/logos/ATAM.png`}
                            width="30px"
                            alt="Atatürk Araştırma Merkezi"
                            title="Atatürk Araştırma Merkezi"
                          />
                          <span style={{ marginLeft: '8px' }}>ATAM</span>
                        </div>
                      }
                    />
                  </Grid>
                )}

                {instList.includes("AKM") && (
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={state.checkedInst.AKM}
                          onChange={handleChangeCheckedInst('AKM')}
                          value="AKM"
                        />
                      }
                      label={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={`${ASSET_IMAGES}/logos/AKM.png`}
                            width="30px"
                            alt="Atatürk Kültür Merkezi"
                            title="Atatürk Kültür Merkezi"
                          />
                          <span style={{ marginLeft: '8px' }}>AKM</span>
                        </div>
                      }
                    />
                  </Grid>
                )}

                {instList.includes("TDK") && (
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={state.checkedInst.TDK}
                          onChange={handleChangeCheckedInst('TDK')}
                          value="TDK"
                        />
                      }
                      label={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={`${ASSET_IMAGES}/logos/TDK.png`}
                            width="30px"
                            alt="Türk Dil Kurumu"
                            title="Türk Dil Kurumu"
                          />
                          <span style={{ marginLeft: '8px' }}>TDK</span>
                        </div>
                      }
                    />
                  </Grid>
                )}

                {instList.includes("TTK") && (
                  <Grid item xs={6}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          checked={state.checkedInst.TTK}
                          onChange={handleChangeCheckedInst('TTK')}
                          value="TTK"
                        />
                      }
                      label={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={`${ASSET_IMAGES}/logos/TTK.png`}
                            width="30px"
                            alt="Türk Tarih Kurumu"
                            title="Türk Tarih Kurumu"
                          />
                          <span style={{ marginLeft: '8px' }}>TTK</span>
                        </div>
                      }
                    />
                  </Grid>
                )}
              </Grid>

            </FormGroup>



          </Grid>

          <Grid item xs={12} sm={3} lg={3} sx={{ alignSelf: 'center', textAlign: 'center' }}>

            <FormGroup row >

              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={completedMeetings}
                    onChange={handleChangeCheckedFinish}
                    value="Tamamlanan Toplantılar"
                  />
                }
                label={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginLeft: '8px' }}>Tamamlanan Toplantılar</span>
                  </div>
                }
              />


              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={ongoingMeetings}
                    onChange={handleChangeCheckedFinish}
                    value="İşlemi devam edenler"
                  />
                }
                label={
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginLeft: '8px' }}>İşlemi devam edenler</span>
                  </div>
                }
              />



            </FormGroup>

          </Grid>







          <Grid item xs={12} sm={6} lg={1}>
            <ButtonGroup sx={{ marginTop: 3 }} size='small'>
              <Button onClick={() => clearFilter()}>Temizle</Button>

            </ButtonGroup>
          </Grid>


        </Grid>

      </AccordionDetails >




    </Accordion >



  )
}





export default MeetingDataTableFilter